import { apiClient } from '@/shared/api/http-client';

import type { ReferralLink } from '../model/referral.types';

export const referralApi = {
    getLink: async (signal?: AbortSignal): Promise<ReferralLink> => {
        return apiClient.get('/referrals/me/link', signal);
    },
};
